export const ADDITIONAL_VALUE_PRODUKTIONSDAUER = "produktionsdauer";
export const ADDITIONAL_VALUE_PRODUKTIONSDAUER_DATE = "produktionsdauerDate";
export const POSTAGE_ID_VERSANDAUFTEILUNG = 5;

export default {
    methods: {
        isSamstagszustellungAllowed( date ) {
            // Check if Versandtermin is Friday
            return date.getDay() == 5 ? true : false;
        }
    }
}
